import { useSWRMutation } from '@tiger/swr';
import { useNavigate } from 'react-router-dom';
import Toast from 'components/Toast';
import API from 'utils/API';
import http from 'utils/http';
import { AcatsSaveReqParamsType, PartialAcatsSaveReqParamsType } from '../type';

export function usePostTransferSave(options: { accountId: number; statementFiles: string[] }) {
    const navigate = useNavigate();
    const { accountId, statementFiles } = options;

    return useSWRMutation<any, Partial<AcatsSaveReqParamsType | PartialAcatsSaveReqParamsType>>(
        API.CUSTOMER.transfer.transferSave(),
        params =>
            http
                .post(API.CUSTOMER.transfer.transferSave(), params, {
                    params: {
                        account_id: accountId
                    }
                })
                .then(res => res.data),
        {
            onSuccess: () =>
                navigate('../result', {
                    replace: true,
                    state: {
                        // checkFiles有可能是空数组
                        haveUploadedFiles: !!statementFiles.length
                    }
                }),
            onError: error => Toast.show(error.message)
        }
    );
}
